export default __webpack_public_path__ + "images/477c5f7678bced6e9ef319a79466e2cc-postcovidteam.png";